module.exports = __webpack_public_path__ + "static/media/uparrow.d169a675.svg";